import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import store from './redux/store';
import Main from './components/Main';
import { captureFbc } from 'utils/capture-fbc';

// Before anything renders: several pages strip the querystring once they mount
// (ThankYou does, to hide the Stripe session id), so fbclid has to be read off
// the landing URL first or it is gone.
captureFbc();

const render = (
    <Provider store={store}>
        <Main />
    </Provider>
);

ReactDOM.render(render, document.getElementById('root'));
